export const SET_IMAGE_IN_OVERLAY = "SET_IMAGE_IN_OVERLAY";
export const CLOSE_OVERLAY = "CLOSE_OVERLAY";
